export const RESOURCE_TYPE_JIRA_HOME = 'JIRA_HOME';
